import DigitRule from './DigitRule';
import UpperCaseRule from './UpperCaseRule';
import LowerCaseRule from './LowerCaseRule';
import SpecialCharRule from './SpecialCharRule';
import UsernameRule from './UsernameRule';
import NoDuplicateUserRule from './NoDuplicateUserRule';
import NoRepeatedCharRule from './NoRepeatedCharRule';
import NoSequentialCharRule from './NoSequentialCharRule';
import NoSpaceRule from './NoSpaceRule';

import { ValidationRuleManager } from '@idm/react-forms';

const registerRuleIfExists = (rule) => {
  if (!ValidationRuleManager.doesRuleExst(rule.ruleName)) {
    ValidationRuleManager.registerRule(rule);
  }
};

// eslint-disable-next-line import/prefer-default-export
export const registerRules = () => {
  registerRuleIfExists(DigitRule);
  registerRuleIfExists(UpperCaseRule);
  registerRuleIfExists(LowerCaseRule);
  registerRuleIfExists(SpecialCharRule);
  registerRuleIfExists(UsernameRule);
  registerRuleIfExists(NoDuplicateUserRule);
  registerRuleIfExists(NoRepeatedCharRule);
  registerRuleIfExists(NoSequentialCharRule);
  registerRuleIfExists(NoSpaceRule);
};
